var nb = require('../../nb');
var $ = nb.opts.$;
// var util = require('../../util');
module.exports = nb.define({
    parent: nb.model.List,
    method:{
        init:function () {
            this.set('itemType',require('../../view/header/BusinessItem'));
            var self = this;
            this.onChange('items',function (inEvent) {
                var items = inEvent.data;
                $.each(items,function (index,item) {
                    item.set('businessHref',item.get('href')+".html");
                });
                return items;
            },this,{before:true});
            this.onChange('businessIndex',function (inEvent,inIndex) {
                var time ;
                var items = this.get('items');
                if(items && items.length>0){
                    this.setActiveIndex(inIndex);
                }else {
                    time=setInterval(function () {
                        self.setActiveIndex(inIndex,time);
                    },1000)
                }
            },this)
        },
        setActiveIndex:function (inIndex,inTime) {
            var self = this;
            var items = this.get('items');
            if(items){
                if(inTime){
                    clearInterval(inTime);
                }
                // $.each(items,function (index,item) {
                //     if(item.get('id')===inId){
                //         self.set('activeIndex',index);
                //     }
                // });
                this.set('activeIndex',inIndex);
            }
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/header/BusinessList.js
// module id = 40
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32